import { EducationCycleAutocomplete } from 'src/models/education-cycle';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useEducationCycles() {
  return useAutocompleteSource<EducationCycleAutocomplete>({
    url: `${EvidenceApiUrl.EDUCATION_CYCLE}/autocomplete`,
  });
}
